// extracted by mini-css-extract-plugin
export default {"work_card":"WorkCard_work_card__WEHfu","img_container":"WorkCard_img_container__8l+30"};